var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactLists = function SvgContactLists(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M16.042 10v1.458a2.5 2.5 0 0 1-2.5 2.5H5.833a1.876 1.876 0 0 0 0 3.75h2.5M7.292 5.833h5.416M7.292 9.167h2.916M5.625 2.292h7.917a2.5 2.5 0 0 1 2.5 2.5v10.416a2.5 2.5 0 0 1-2.5 2.5H5.625a1.666 1.666 0 0 1-1.667-1.666V3.958c0-.921.746-1.666 1.667-1.666"
  })));
};
export default SvgContactLists;